import React, { FC, useContext } from 'react'
import { HiddenMenu, StyledDropDown, MenuItem, MainContainer } from './styles'
import ArrowIcon from '../../icons/ArrowIcon'
import { Specialty } from '../../../../types/homePage'
import { AppDataContext } from '../../../../providers/AppData'
import useClickOutside from '../../../../hooks/useClickOutside'
import getDomainName from '../../../../utils/getDomainName'
import { purifyTenantDomain } from '../../../../utils/url'

type CustomDropDownProps = {
  name: string
  city: string
  specialties: Specialty[]
  typeOfProfile?: string
}

const CustomDropDown: FC<CustomDropDownProps> = ({ name, specialties, city, typeOfProfile }) => {
  const [open, setOpen] = React.useState(false)
  const { locale, language } = useContext(AppDataContext)
  const menuRef = React.useRef<HTMLDivElement>(null)
  const domainName = getDomainName()
  const originWithLang = purifyTenantDomain(domainName, locale)
  const toggleMenu = () => {
    setOpen((prev) => !prev)
  }

  const toggleClose = () => {
    setOpen(false)
  }

  useClickOutside(menuRef, toggleClose)

  if (!specialties.length) {
    return null
  }

  return (
    <MainContainer open={open} ref={menuRef}>
      <StyledDropDown onClick={toggleMenu} open={open}>
        <span style={{ textAlign: 'start' }}>{name}</span>
        <ArrowIcon style={{ transform: open ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.3s' }} />
      </StyledDropDown>

      {open && (
        <HiddenMenu>
          {specialties.map((specialty) => (
            <MenuItem
              href={`${originWithLang}/find/${specialty.slug[0]}/${city}/${
                typeOfProfile ? typeOfProfile : 'specialists'
              }`}
              key={specialty.id}
            >
              {specialty.name[language]}
            </MenuItem>
          ))}
        </HiddenMenu>
      )}
    </MainContainer>
  )
}

export default CustomDropDown
